module.exports = __webpack_public_path__ + "img/LabeebaMiah.db2a942b.jpg";